import { http, apiEndPoints } from "../../utils/http";
export const getLmsURL = (data) => {
  return http.post(apiEndPoints.GET_LMS_URL, data, {
    headers: {
      Authorization: `Bearer ${data.token}`,
    },
  });
};
